const maskCreditCardNumber = (cardNumber: string, maskCenter: boolean = false, endFour: boolean = false) => {
  if (maskCenter) {
    // 14-19 haneli kart numaralarını destekle
    if (cardNumber.length < 14 || cardNumber.length > 19) {
      return 'Geçersiz kart numarası uzunluğu';
    }

    const first4 = cardNumber.substring(0, 4);
    const last4 = cardNumber.substring(cardNumber.length - 4);
    const middleLength = cardNumber.length - 8; // İlk 4 + son 4 = 8, geri kalan ortadaki kısım

    // Ortadaki kısmı yıldızla maskele
    const maskedMiddle = '*'.repeat(middleLength);

    return first4 + maskedMiddle + last4;
  } else if (endFour) {
    // İlk 8 hane maskesiz + 4 maske + son 4 hane maskesiz
    const first8 = cardNumber?.substring(0, 8);
    const last4 = cardNumber?.substring(cardNumber.length - 4);

    return `${first8}****${last4}`;
  } else {
    const first4 = cardNumber?.substring(0, 4);
    const fiveAndSix = cardNumber?.substring(4, 6);
    const last2 = cardNumber?.substring(cardNumber.length - 2);

    return `${first4} ${fiveAndSix}** **** **${last2}`;
  }
};
export default maskCreditCardNumber;
